import { defineStore } from 'pinia'
import axios from "axios";
import {computed, ref} from "vue";
import {useNotificationStore} from "@/stores/notifications.js";
import {useRouter} from "vue-router";

export const useUserStore = defineStore('user', () => {
  const router = useRouter();
  const notificationStore = useNotificationStore();

  const user = ref(localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null);

  const forceNextRefresh = ref(false);

  const getUser = () => {
    return new Promise((resolve, reject) => {
      if(user.value !== null && !forceNextRefresh.value) {
        forceNextRefresh.value = false;
        return resolve(user);
      }

      refreshUser()
        .then((user) => resolve(user))
        .catch((error) => reject(error))
    })
  };

  const refreshUser = () => {
    return new Promise((resolve, reject) => {
      axios.get('/v1/me')
        .then((response) => {
          if(response.data.data) {
            localStorage.setItem('user', JSON.stringify(response.data.data));
            user.value = response.data.data;
          }
          resolve(user);
        })
        .catch((error) => reject(error));
    });
  };

  const forceRefreshNextFetch = () => {
    forceNextRefresh.value = true;
  }

  const userCanUpscaleImages = computed(() => {
    if(!user.value) {
      return false;
    }

    return userHasFeature('ai_upscaling') && userHasSecret('stability_ai_api_key');
  });

  const userHasFeature = (featureName) => {
    return user.value.plan.features.findIndex((feature) => feature.name === featureName) !== -1
  }

  const userHasSecret = (secretKey) => {
    return user.value.secrets.findIndex((secret) => secret.key === secretKey) !== -1;
  }

  const logout = () => {
    return axios.post('auth/logout')
      .then((response) => {
        if(response.status !== 204) {
          return notificationStore.showError('There was a problem logging you out.');
        }

        localStorage.removeItem('user');
        user.value = null;
        router.push({name: 'home'});
      })
      .catch(() => notificationStore.showError('There was a problem logging you out.'))
  }

  return {
    user,
    userCanUpscaleImages,
    getUser,
    refreshUser,
    forceRefreshNextFetch,
    userHasFeature,
    userHasSecret,
    logout
  };
});
